import { format, isSameDay, parseISO, subDays } from "date-fns";

import { isFilterSet } from "../../utils/filters";
import { Deposit } from "./DepositCard/deposit-dtos";
import { DepositFilterValues, DepositListParams, StockStatusOption } from "./types";

export const DEPOSITS_PAGE_SIZE = 10;

export const DEPOSITS_DEFAULT_ORDERING = "-backend_creation_time";

export const STOCK_STATUS_OPTIONS: StockStatusOption[] = [
  "FOR_SALE",
  "SALE_PENDING",
  "SOLD",
  "EDITED",
  "REMOVED",
  "SPLIT",
];

export const DEFAULT_STOCK_STATUS: StockStatusOption = "FOR_SALE";

export const DEFAULT_DEPOSIT_FILTERS: DepositFilterValues = {
  stock_status: DEFAULT_STOCK_STATUS,
  commodity_id: "",
  quality: "",
  aggregator_ids: "",
};

export const toStockStatusOption = (value: unknown): StockStatusOption =>
  STOCK_STATUS_OPTIONS.find(option => option === value) ?? DEFAULT_STOCK_STATUS;

export const buildDepositParams = (
  filters: DepositFilterValues,
  page: number
): DepositListParams => ({
  page_size: DEPOSITS_PAGE_SIZE,
  page,
  ordering: DEPOSITS_DEFAULT_ORDERING,
  stock_status: toStockStatusOption(filters.stock_status),
  with_status: true,
  with_location: true,
  ...(isFilterSet(filters.commodity_id) ? { commodity_id: filters.commodity_id } : {}),
  ...(isFilterSet(filters.quality) ? { quality: filters.quality } : {}),
  ...(isFilterSet(filters.aggregator_ids) ? { aggregator_ids: filters.aggregator_ids } : {}),
});

export const formatDepositDate = (
  date: string,
  labels: { today: string; yesterday: string },
  now: Date = new Date()
): string => {
  const depositDate = parseISO(date);
  const time = format(depositDate, "HH:mm");

  if (isSameDay(depositDate, now)) {
    return `${labels.today} - ${time}`;
  }

  if (isSameDay(depositDate, subDays(now, 1))) {
    return `${labels.yesterday} - ${time}`;
  }

  return format(depositDate, "d MMM yyyy, HH:mm");
};

export const canMakeOffer = (deposit: Deposit): boolean =>
  deposit.stock_status
    ? deposit.stock_status.can_receive_offers
    : !deposit.has_direct_offer_same_trader;

export const offersClosedNoticeKey = (deposit: Deposit): string =>
  deposit.has_direct_offer_same_trader
    ? "farmersMarket.depositCard.existingOffer"
    : "farmersMarket.depositCard.offersClosed";
